import requester from '@/lib/axios';
import { ActivityValidationResult } from './activityElement/codeEditorActivityServices';

const BASE_URL = '/judge0/execution';

type ExecuteCodeParams = {
  solutionCode: string;
  language: string;
  testCases: { input: string; expectedOutput: string }[];
};

export async function executeCode(body: ExecuteCodeParams) {
  const { data } = await requester().post<ActivityValidationResult>(
    `${BASE_URL}/`,
    body,
  );

  return data;
}
